module.exports = __webpack_public_path__ + "img/sp04.8d7ed67c.png";